/* ---------- Hero: the headline beside the one quote the page leads with ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-20);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 36rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
/* Who is speaking, counted from the quotes themselves. */
.figures {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3) var(--sp-8);
  margin-top: var(--sp-8);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
  color: var(--text-muted);
}
.figures strong {
  margin-right: 0.3em;
  font-family: var(--font-display);
  font-size: var(--fs-2xl, 1.75rem);
  font-weight: 700;
  letter-spacing: var(--tracking-heading);
  color: var(--text-strong);
}

/* The lead quote: type as large as the headline's second tier, on its own panel. */
.pull {
  margin: 0;
  padding: var(--sp-8);
  border: 1px solid var(--border);
  border-left: 3px solid var(--accent);
  border-radius: var(--radius-lg);
  background: var(--surface-raised);
  box-shadow: var(--shadow-lg);
}
.pullQuote {
  margin: 0;
}
.pullQuote p {
  margin: 0;
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 1.1vw + 1.1rem, 2.25rem);
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text-strong);
  text-wrap: pretty;
}
.pullWho {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  margin-top: var(--sp-8);
}
.pullPhoto {
  flex: none;
  width: 5.5rem;
  border-radius: 50%;
}
.pullName {
  display: block;
  font-size: var(--fs-md);
  color: var(--text-strong);
}
.pullRole {
  display: block;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.pullLinks {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-6);
  margin: var(--sp-6) 0 0;
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border);
  font-size: var(--fs-sm);
  font-weight: 600;
}
.pullLinks a {
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.pullLinks a:hover {
  color: var(--accent-text);
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
    gap: var(--sp-16);
  }
  .pull {
    padding: var(--sp-10);
  }
}

/* ---------- The quotes: balanced columns, each card as tall as its quote ---------- */
.wall {
  columns: 3 18rem;
  column-gap: var(--sp-6);
}
.brick {
  margin-bottom: var(--sp-6);
  break-inside: avoid;
}

/* The firms, as a list read top to bottom: a change of pace from the cards above. */
.rows {
  border-bottom: 1px solid var(--border-strong);
}
